/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/prop-types */
import { CurrencyInput, CurrencyLabel } from 'Modules/Currency';
import { debounce, isArray } from 'lodash';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Placeholder } from 'semantic-ui-react';

import { CURRENCY_SYMBOLS } from '../../../../../constants/commons';
import { consultFeeEstimate } from '../../../../../redux/modules/webChat/actions';

import styles from './FeeContent.less';

const getError = error => {
  return isArray(error?.data?.devErr) && error?.data?.devErr?.length > 0
    ? error?.data?.devErr[0].message
    : error?.data?.message ?? '';
};

// build
const FeeTotal = props => {
  const { isReadOnly, userDiscount, setUserDiscount, consultId, consultFee, isViewMode } = props;
  const dispatch = useDispatch();
  const {
    estimate,
    status: { estimate: estimateStatus },
    error: { estimate: errEstimate, updateFee: errUpdateFee },
  } = useSelector(state => state.webChat.consultFee);

  const {
    consultDiscount,
    discount,
    subTotal,
    totalPrice: total,
    taxTotal,
    taxName,
    currency,
    loyaltyAmount,
    appliedAdminFee,
  } = consultFee?.consult?.status === 1 ? estimate || { feeSetting: {} } : consultFee;

  const handleChange = debounce(async value => {
    dispatch(consultFeeEstimate(consultId, value));
  }, 1000);

  const errorEst = getError(errEstimate ?? errUpdateFee);

  const renderWithSkeleton = child =>
    estimateStatus === 0 ? (
      <div style={{ width: '60px' }}>
        <Placeholder>
          <Placeholder.Line />
        </Placeholder>
      </div>
    ) : (
      child
    );

  useEffect(() => {
    if (setUserDiscount) {
      setUserDiscount(consultDiscount);
    }
  }, [estimate, setUserDiscount]);

  const containerClass =
    isViewMode && !isReadOnly ? styles.feeChatContainer : styles.feeTotalContainer;

  return (
    <div className={containerClass}>
      <div>
        {!appliedAdminFee && (
          <>
            <div className={styles.item}>
              <div className={styles.label}>Subtotal</div>
              <div className={styles.value}>
                {renderWithSkeleton(<CurrencyLabel value={subTotal} />)}
              </div>
            </div>

            <div className={styles.item}>
              <div className={styles.label}>
                <strong style={{ fontWeight: 'normal' }}>Coupon</strong>
              </div>
              <div className={styles.value}>
                {renderWithSkeleton(<CurrencyLabel value={-discount} />)}
              </div>
            </div>
            <div className={styles.item}>
              <div className={styles.label}>Discount</div>
              <div className={styles.value}>
                {isViewMode && !isReadOnly ? (
                  renderWithSkeleton(<CurrencyLabel value={-userDiscount} />)
                ) : (
                  <CurrencyInput
                    onChange={value => {
                      setUserDiscount(value);
                      handleChange(value);
                    }}
                    value={
                      consultFee?.consult?.status === 1 ? userDiscount : consultFee?.consultDiscount
                    }
                    disabled={isReadOnly}
                  />
                )}
              </div>
            </div>
            {loyaltyAmount > 0 && (
              <div className={styles.item}>
                <div className={styles.label}>Used Points</div>
                <div className={styles.value}>
                  <CurrencyLabel value={-loyaltyAmount} />
                </div>
              </div>
            )}
            {taxTotal > 0 && (
              <div className={styles.item}>
                <div className={styles.label}>{taxName}</div>
                <div className={styles.value}>
                  {renderWithSkeleton(<CurrencyLabel value={taxTotal} />)}
                </div>
              </div>
            )}
          </>
        )}

        <div className={styles.item} style={{ fontWeight: 600, color: '#272727' }}>
          <div className={styles.label} style={{ color: '#272727' }}>
            Total
          </div>
          <div className={styles.value}>
            {renderWithSkeleton(
              <span>
                {CURRENCY_SYMBOLS[currency]} <CurrencyLabel value={total <= 0 ? 0 : total} />
              </span>,
            )}
          </div>
        </div>
        {errorEst && (
          <div style={{ color: 'red' }} className={styles.item}>
            {errorEst}
          </div>
        )}
      </div>
    </div>
  );
};

export default FeeTotal;
